export const BRANCH_LIST_REQUEST = "BRANCH_LIST_REQUEST"
export const BRANCH_LIST_SUCCESS = "BRANCH_LIST_SUCCESS"
export const BRANCH_LIST_FAIL = "BRANCH_LIST_FAIL"

